import React from 'react';
import { ModalContextType, ModalType, useModalContext } from 'src/hooks/useModal';
import { ScrollModal } from '../../../components/primitives/ScrollModal';
import { PositionModalWrapper } from '../FlowCommons/PositionModalWrapper';
import { CompoundFeesModalContent } from './CompoundFeesModalContent';

export const CompoundFeesModal = () => {
  const { type, args, close } = useModalContext() as ModalContextType<{
    positionAddress: string;
  }>;

  return (
    <ScrollModal open={type === ModalType.CompoundFees} setOpen={close}>
      <PositionModalWrapper
        positionAddress={args.positionAddress}
        title="Compound Fees"
        modernStyle={true}
      >
        {(params) => <CompoundFeesModalContent {...params} />}
      </PositionModalWrapper>
    </ScrollModal>
  );
};
